import styled from "styled-components";

const ProjectsSc = styled.div`
  width: 100vw;
  position: absolute;
  top: 55px;
  padding: 10px;
  .project-navbar {
    position: fixed;
  }

  .content-tabs {
    width: 100vw;
    height: 100vh;
  }
  .overall-project-container {
    height: 90vh;
    display: flex;
    padding: 10px;
    justify-content: space-around;
    align-items: center;
    gap: 15px;
    flex-flow: wrap;
  }

  .project-card {
    background-color: #e6dddd;
    padding: 25px;
    height: 200px;
    width: 25%;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: all 0.3s ease-in-out;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  }

  .project-card:hover {
    transform: translateY(-5px);
    box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.2);
  }

  .project-card-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .project-card-heading p {
    margin: 0;
    font-size: 0.9rem;
    font-weight: 600;
    color: #1e59d9;
  }

  .project-card-description {
    font-size: 1rem;
    line-height: 1.5;
    margin-top: 10px;
    color: #333;
  }

  .project-member {
    display: flex;
  }
  .bloc-tabs {
    display: flex;
    justify-content: space-around;
    width: 100vw;
    padding: 10px;
    background: #d9d9d9;
  }
  .tabs {
    text-align: center;
    width: 50%;
    cursor: pointer;
    background-color: #d9d9d9;
    position: relative;
    border-style: none;
  }

  .active-tabs {
    color: blue;
  }
  .project-container {
    display: flex;
    flex-direction: column;
    margin-bottom: 3rem;
  }
  .project-lead-details {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .project-title {
    display: flex;
    justify-content: space-between;
  }
  .project-team-lead {
    display: flex;
  }
  .team-member-image {
    width: 150px;
    height: 150px;
  }
  .project-member {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .project-member-container {
    display: flex;
    justify-content: space-around;
  }
  .project-card-main {
    display: flex;
  }
  .performance-container {
    background-color: #d9d9d9;
    display: flex;
    justify-content: space-between;
    margin: 20px;
    width: 100%;
    padding: 20px 10px;
    border-radius: 5px;
  }
  .data-part {
    width: 100%;
  }
  .perform-status {
    background-color: greenyellow;
    padding: 3px;
    border-radius: 3px;
  }
  .goals-main-container {
    display: flex;
    justify-content: space-between;
    gap: 25px;
  }
  .comment-section {
    background-color: #d9d9d9;
    width: 50%;
  }
  .project-description {
    text-align: center;
  }
  .my-goals-container {
    display: flex;
    background-color: #d9d9d9;
  }
  .individual-view {
    background-color: #d9d9d9;
    display: flex;
    justify-content: space-between;
    padding: 10px 5px;
    border-radius: 5px;
  }
  .individual-member-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    margin-top: 4rem;
  }
  @media (width: 1030px) {
    .overall-project-container {
      height: 90vh;
      display: flex;
      flex-direction: column;
      padding: 10px;
      justify-content: space-between;
      align-items: center;
      gap: 15px;
      /* flex-flow: wrap; */
    }
    .project-card {
      background-color: #b2b5fc;
      padding: 25px;
      height: 200px;
      width: 30%;
      /* max-width: 20%; */
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      transition: 1s;
    }
  }
`;

export default ProjectsSc;
